<template lang="pug">
div.header
    b-navbar
        b-navbar-brand(href="/scop3ptm")
            // img(class="logo" src="../assets/logos/scop3p-logo.png")
            h3.d-inline-block Scop3PTM
            span.badge.badge-info.align-top.ml-1 BETA
        p(style="color: white;") {{ $route.name }}
        b-navbar-nav.ml-auto(v-if="$route.name !== 'home'")
            b-nav-form
                b-form-input(size="sm" class="mr-sm-2"
                    v-model="proteinSearchValue"
                    v-on:keyup.enter="getDbResponse(proteinSearchValue)"
                    placeholder="Search")
                button(
                    size="sm" class="my-2 my-sm-0" type="button"
                    @click="getDbResponse(proteinSearchValue)") Search
</template>

<script>
import axios from "axios"
import router from '../router'
export default {
    name: 'CustomHeader',
    data: function() {
        return {
            searchString: null,
            showSearch: false,
            proteinSearchValue: '',
            response: []
        }
    },
    watch: {
        $route(to, from) {
            if(to.name !== 'home') {
                this.showSearch = true
            }
        }
    },
    methods: {
        async getDbResponse (protein) {
            const apiProtein = '/scop3ptm/api/protein'
            const response = await axios
                .get(apiProtein, { 
                    params: { protein: protein } 
                })
                .catch(e => console.log(e))
               
            // JSON responses are automatically parsed.
            if (response !== null) {
                this.response = response.data
                this.$store.commit('setSearchString', protein)
                router.push({
                    name: 'summary',
                    params: {
                        protein: protein,
                        info: response.data[0]
                    }
                })
            }
        }
    }
    // computed: {
    //     showSearchBar() {
    //         console.log(this.$router.currentRoute)
    //         return this.$router.currentRoute.name !== 'home'
    //     }
    // }
};
</script>

<style lang="scss">
@import '../assets/scss/variables';
.header {
    // background-color: $primary;
    border-bottom: 1px solid $secondary;
    .navbar {
        padding: 0 1rem;
    }
}

img.logo {
    height: 49px;
    width: 78px;
}
span sub {
    font-size:11px;
}
.badge {
    // display: inline-block !important;
    // padding:5px 10px;
    // line-height: 1.7rem;
    // font-size: .975rem;
    // position: relative;
    background-color: $secondary !important;
}

</style>
